import Loadable from 'react/components/loadable';

const ActiveContacts = Loadable({
  loader: () => import('../../pages/dashboard/active_contacts/active_contacts'),
});

angular.module('gym').value('ActiveContacts', ActiveContacts);
